<template>
  <card card-body-classes="table-full-width">
    <edit-distributor-client :show="showEdit"
                             :form-details="editDistributorClient"
                             :system_accounts="system_accounts"
                             :distributor_id="$route.params.id"
                             @close="showEdit=false"/>
    <template slot="header">
      <h4 class="card-title">{{ $t('distributor_clients.tableTitle') }}</h4>
    </template>
    <div>
      <div
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <el-select
          class="select-primary mb-3 pagination-select"
          v-model="pagination.perPage"
          placeholder="Per page">
          <el-option
            class="select-primary"
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"/>
        </el-select>

        <div class="row">
          <div class="col-12">
            <base-input>
              <el-input
                type="search"
                class="mb-6 search-input"
                prefix-icon="el-icon-search"
                :placeholder="$t('generic.searchInTablePlaceholder')"
                v-model="searchQuery"
                aria-controls="datatables"/>
            </base-input>
          </div>
        </div>
      </div>
      <el-table v-loading="loading" :data="queriedData" :empty-text="$t('generic.noData')">
        <el-table-column
          v-for="column in tableColumns"
          :key="column.label"
          :prop="column.prop"
          :label="$t(column.label)"
          :min-width="column.minWidth"
        >
        </el-table-column>


        <el-table-column
          :label="$t('distributor_clients.details.system_account_id')"
          width="150"
        >
          <template v-slot="props">
            <router-link v-if="props.row.system_account_id"
                         :to="linkUtils.systemAccountPath($router, props.row)">
              {{ props.row.system_account_id }}
            </router-link>
          </template>

        </el-table-column>

        <el-table-column
          :label="$t('generic.updatedBy')"
          width="150"
        >
          <template v-slot="props">
            {{ props.row.modified_by }}
          </template>
        </el-table-column>

        <el-table-column
          v-if="allowEditDistributorClient"
          :min-width="60" align="right">
          <div slot-scope="props">
            <base-button
              v-if="$auth.can({distributor_client: 'update'}, 'permissions')"
              @click.native="handleEdit(props.$index, props.row)"
              class="mr-2"
              type="info"
              size="sm"
              icon
              round
              simple>
              <i class="tim-icons icon-pencil"></i>
            </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div
      slot="footer"
      class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
    >
      <div class="">
        <p class="card-category">
          {{ $t('generic.tablePaginationSummary', {from: from + 1, to: to, total: total}) }}
        </p>
      </div>
      <base-pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      >
      </base-pagination>
    </div>
  </card>
</template>
<script>
import {BaseAlert, BasePagination} from "src/components";
import {Option, Select, Table, TableColumn} from "element-ui";
import Fuse from "fuse.js";
import {mapActions, mapState} from "vuex";
import EditDistributorClient from "./EditDistributorClient.vue";
import linkUtils from "@/util/link_utils";

export default {
  name: 'distributor-clients',
  components: {
    EditDistributorClient,
    BasePagination,
    BaseAlert,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    linkUtils() {
      return linkUtils
    },
    ...mapState({
      error: state => state.distributor_clients.error,
      loading: state => state.distributor_clients.loading,
      distributor_clients: state => state.distributor_clients.data,
      distributor: state => state.distributors.single,
      system_accounts_loading: state => state.system_accounts.loading,
      system_accounts: state => state.system_accounts.all,
    }),
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      allowEditDistributorClient: false,
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['name'],
      tableColumns: [
        {
          prop: 'created_at',
          label: 'generic.created',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time(cellValue)
          },
          minWidth: 120
        }, {
          prop: 'updated_at',
          label: 'generic.updated',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time(cellValue)
          },
          minWidth: 120
        },
        {
          prop: 'id',
          label: 'generic.id',
          minWidth: 150
        },
        {
          prop: 'name',
          label: 'distributor_clients.details.name',
          minWidth: 100
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      showEdit: false,
      editDistributorClient: {},
    };
  },
  methods: {
    ...mapActions(['LoadDistributorClients', 'LoadSystemAccounts']),
    handleEdit(index, row) {
      this.editDistributorClient = {
        id: row.id,
        name: row.name,
        system_account_id: row.system_account_id ? row.system_account_id : null,
      };
      this.showEdit = true;
    },
  },
  mounted() {
    this.LoadDistributorClients(this.$route.params.id);
    // systemAccounts loaded on distributor load see watch.distributor function.
  },
  watch: {
    "distributor_clients"(data) {
      this.tableData = data
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: this.propsToSearch,
        threshold: 0.3
      });
    },
    "distributor"(data) {
      // load system accounts only if allowed.
      if (data != null && data.id == this.$route.params.id && data.type == 'internal' && this.$auth.can({discount: 'update'}, 'permissions')) {
        this.allowEditDistributorClient = true
        this.LoadSystemAccounts();
      }
    },
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  }
};
</script>
<style></style>
